<template>
    <div class="modal fade" id="rider_modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="myModalLabel">Add / Update Rider: {{rider.name}}</h4>
                </div>
                <form method="post" @submit.prevent="updateRider()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="name">Name</label>
                            <input v-model="rider.name" type="text" required="required" class="form-control" id="name" placeholder="Name...">
                        </div>
                        <div class="form-group">
                            <label >Contact</label>
                            <input v-model="rider.contact" type="text" required="required" class="form-control" placeholder="Contact...">
                        </div>
                        <div class="form-group">
                            <label>Vehicle Number</label>
                            <input v-model="rider.vehicleNumber" required="required" type="text" class="form-control" placeholder="Vehicle No...">
                        </div>
                            <div class="form-group">
                                <label>Warehouse</label>
                                <multiselect :disabled="isBranchUser" v-model="selectedRestaurant" :options="restaurants" label="name" track-by="name" @input="fetchBranchesOfRestaurant()"></multiselect>
                            </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                                    <div class="sk-bounce1"></div>
                                    <div class="sk-bounce2"></div>
                                    <div class="sk-bounce3"></div>
                                </div>
                            </div>
                        </div>
                            <div class="form-group">
                                <label>Vendors</label>
                                <multiselect :disabled="isBranchUser" v-model="rider.branchesByBranchId" :options="branches" :custom-label="opt=> opt.areasByAreaId.name" track-by="id"></multiselect>
                            </div>
                            <div v-if="rider.id===0">
                                <div class="form-group">
                                    <label>Rider Username</label>
                                    <input v-model="rider.contact" readonly required="required" type="text" class="form-control" placeholder="Username">
                                </div>     
                                <div class="form-group">
                                    <label>Rider Password</label>
                                    <input v-model="password" required="required" type="text" class="form-control" placeholder="Password">
                                </div>  
                            </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
    /* eslint-disable */
    import Multiselect from 'vue-multiselect'
    export default {
        components: { Multiselect },
        name: "AddUpdateRider",
        data:function() {
            return {
                rider: {
                    "id": 0,
                    "name": "",
                    "contact": null,
                    "vehicleNumber": "",
                    "branchesByBranchId":"",
                },
                selectedRestaurant:"",
                loggedInRole:"",
                isHideSpinner: "hide",
                restaurants:[],
                branches:[],
                email:'',
                username:'',
                password:''
            };
        },
        props: ["where"],
        computed: {
          isBranchUser(){
            return this.$store.state.user.userRolesById[0].role === 'ROLE_BRANCH'
          }
        },
        mounted: function () {
            let user = this.$store.state.user;
            this.loggedInRole = this.$store.state.user;
            let role = user.userRolesById[0].role;
            if(role === 'ROLE_ADMIN'){
                console.log("in admin");
                this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
                    this.restaurants = resp.data;
                });
            }else if(role === 'ROLE_USER'){
                this.selectedRestaurant = this.$store.state.user.restaurant;
                this.restaurants.push({id: this.$store.state.user.restaurant.id, name: this.$store.state.user.restaurant.name});
                this.fetchBranchesOfRestaurant();
            }
            console.log(this.where);
        },
        methods: {
            load: function (riderId) {
                if(riderId > 0){
                    this.$http.get(this.$store.state.mainAppURL + "riders/get_rider_detail", {params: {rider_id: riderId}}).then(resp => {
                        this.rider = resp.data;
                        this.selectedRestaurant= this.rider.branchesByBranchId.restaurantsByRestaurantId;
                    }).catch( ex => {
                      this.showErrorMessage(ex);
                    });
                }else{
                    this.resetData();
                    this.populateRestaurantAndBranchForBranchUser(this.$store.state.user)
                }
                $("#rider_modal").modal("show");
            },
            fetchBranchesOfRestaurant: function () {
                this.isHideSpinner = "";
                let params = new URLSearchParams();
                params.append("restaurant_id", this.selectedRestaurant.id);
                    this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_branches", params).then(resp => {
                        this.isHideSpinner = "hide";
                        this.branches = resp.data;
                    });
            },
            updateRider: function () {
                    Swal.fire({
                        title: 'Please Wait! We are processing the data.',
                        type: 'info',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        onBeforeOpen: () => {
                            Swal.showLoading();
                        },
                    });
                    let formData= new FormData();
                    formData.append("rider", JSON.stringify(this.rider));
                    formData.append("username", this.rider.contact);
                    formData.append("password", this.password);
                    this.$http.post(this.$store.state.mainAppURL + "riders/", formData).then(resp => {
                        Swal.close();
                        if (resp.data) {
                            this.$parent.tableDraw();
                            $("#rider_modal").modal("hide");
                            this.resetData();
                            swal("SUCCESS!", "Rider has been updated successfully!", "success");
                        } else {
                            swal("Error!", "Contact Number or Username May Already Registered.\nPlease try again!", "error");
                        }
                    }).catch(ex => {
                        swal("Error!", ex + "\nPlease try again!!", "error");
                    });
            },
            resetData: function () {
                this.rider = {
                    "id": 0,
                    "name": "",
                    "contact": null,
                    "vehicleNumber": "",
                    "branchesByBranchId":"",
                };
                this.selectedRestaurant = "";
                this.branches = [];
                this.password="";
            },
            populateRestaurantAndBranchForBranchUser(user) {
              if (this.isBranchUser) {
                this.selectedRestaurant = user.restaurant
                this.rider.branchesByBranchId = user.branch
              }
            }
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
